import Choices from 'choices.js';
import { merge } from 'lodash';

class Select {
  el: any;
  instance: any = null;
  options: any = {
    searchEnabled: false,
    shouldSort: false,
    itemSelectText: '',
  };

  constructor(el: any, options: any = {}) {
    this.el = el;
    this.options = merge(this.options, options);
    this.instantiate(this.el, this.options);
    this.addEventListeners();
  }

  private instantiate(el: any, options: any) {
    this.instance = new Choices(el, {
      ...options,
    });
  }

  private addEventListeners() {
    (window as any).emitter.on('select:setChoice', (value: any) => {
      this.instance.setChoiceByValue(value);
    });
  }
}

export default Select;
